
import { Link } from 'react-router-dom';

export default function Footer() {
  const handleLinkClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <footer className="bg-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          <div className="sm:col-span-2 lg:col-span-1">
            <h3 className="text-lg sm:text-xl font-bold mb-2" style={{ fontFamily: 'Helvetica, Arial, sans-serif' }}>
              CANAL REALTY
            </h3>
            <div className="mb-4">
              <img 
                src="https://www.dropbox.com/scl/fi/aweyw20bwdwl12hukqs3w/Canal-Icon.png?rlkey=436utm2ijegfgnektjcroe1xx&dl=1"
                alt="Canal Icon"
                className="h-4 sm:h-5 w-auto"
              />
            </div>
          </div>
          
          <div>
            <h4 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4" style={{ fontFamily: 'Helvetica, Arial, sans-serif' }}>
              Projects
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/projects/commercial" className="text-gray-300 hover:text-white transition-colors text-sm" onClick={handleLinkClick}>
                  Commercial
                </Link>
              </li>
              <li>
                <Link to="/projects/residential" className="text-gray-300 hover:text-white transition-colors text-sm" onClick={handleLinkClick}>
                  Residential
                </Link>
              </li>
              <li>
                <Link to="/projects/industrial" className="text-gray-300 hover:text-white transition-colors text-sm" onClick={handleLinkClick}>
                  Industrial
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4" style={{ fontFamily: 'Helvetica, Arial, sans-serif' }}>
              Company
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" onClick={handleLinkClick} className="text-gray-300 hover:text-white transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-white transition-colors text-sm" onClick={handleLinkClick}>
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/investor-portal" className="text-gray-300 hover:text-white transition-colors text-sm" onClick={handleLinkClick}>
                  Investor Portal
                </Link>
              </li>
            </ul>
          </div>
          
          <div className="sm:col-span-2 lg:col-span-1">
            <h4 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4" style={{ fontFamily: 'Helvetica, Arial, sans-serif' }}>
              Contact Info
            </h4>
            <div className="space-y-1 sm:space-y-2 text-xs sm:text-sm text-gray-300">
              <p>1340 Smith Avenue, Suite 300</p>
              <p>Baltimore, MD 21209</p>
              <p>Phone: (410) 630-6990</p>
              <p>Email: info@canalgroup.us</p>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-700 pt-6 sm:pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center">
            <p className="text-gray-400 text-xs sm:text-sm mb-4 sm:mb-0">
              © 2024 Canal Realty. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
